export default {"src":"/_next/static/media/acorn-white.62859911.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};